import Vue from 'vue'

const ZF_ORIGIN = 'https://zf.buildbee.cn'

const brandState = Vue.observable({
  id: 'zf',
  name: '',
  loginTitle: '',
  loginTitleSize: '40px',
  loginIntro: '',
  loginLogo: '',
  homeLogo: '',
  favicon: '/logo2.png',
  userManuals: []
})

let loadPromise = null
let loadedAt = 0

function hostName() {
  if (typeof window === 'undefined' || !window.location) return ''
  return String(window.location.hostname || '').toLowerCase()
}

export function isWuhuanSite() {
  return hostName() === 'wh.buildbee.cn'
}

function builtinBrand() {
  if (isWuhuanSite()) {
    return {
      id: 'wh',
      name: '五环班前通',
      loginTitle: '五环工程项目班前教育管理系统',
      loginTitleSize: '40px',
      loginIntro:
        '面向工程施工一线班组，围绕每日班前教育，提供教育计划、作业交底、人员签到、培训影像及不合格整改闭环管理，帮助项目及时掌握教育执行与覆盖情况，实现标准化、可溯源的班前安全交底。',
      loginLogo: require('@/assets/img/lq02.png'),
      homeLogo: require('@/assets/img/lq.png'),
      favicon: '/lq02.png'
    }
  }
  return {
    id: 'zf',
    name: '筑蜂工程通',
    loginTitle: '筑蜂工程项目业务管控平台',
    loginTitleSize: '40px',
    loginIntro:
      '以工程建设过程中“人、机、料、法、环”五大关键影响因素为核心，为中层管理者提供集业务协同、过程监测和事后分析的项目辅助管理系统，实现精细化、标准化和可溯源的管理目标',
    loginLogo: require('@/assets/img/logo.png'),
    homeLogo: require('@/assets/img/logo2.png'),
    favicon: '/logo2.png'
  }
}

function assignBrand(next) {
  Object.keys(brandState).forEach((key) => {
    if (Object.prototype.hasOwnProperty.call(next, key) && next[key] != null) {
      brandState[key] = next[key]
    }
  })
}

function normalizeManuals(raw) {
  if (Array.isArray(raw)) return raw.filter(Boolean)
  if (raw == null || raw === '') return []
  if (typeof raw === 'string') {
    try {
      const parsed = JSON.parse(raw)
      return Array.isArray(parsed) ? parsed.filter(Boolean) : []
    } catch (e) {
      return []
    }
  }
  return []
}

function mergeBrand(row) {
  const fallback = builtinBrand()
  if (!row) return Object.assign({}, fallback, { userManuals: [] })
  const loginLogo = row.loginLogo || fallback.loginLogo
  const homeLogo = row.homeLogo || row.loginLogo || fallback.homeLogo
  const favicon =
    loginLogo && String(loginLogo).indexOf('data:image/') === 0
      ? loginLogo
      : fallback.favicon
  return {
    id: fallback.id,
    name: row.shortName || fallback.name,
    loginTitle: row.fullName || fallback.loginTitle,
    loginTitleSize: '40px',
    loginIntro: row.intro || fallback.loginIntro,
    loginLogo,
    homeLogo,
    favicon,
    userManuals: normalizeManuals(row.userManuals)
  }
}

export function siteUserManuals() {
  const brand = siteBrand()
  return normalizeManuals(brand && brand.userManuals)
}

export function hasSiteUserManuals() {
  return siteUserManuals().length > 0
}

export function siteBrand() {
  if (!brandState.name) {
    assignBrand(builtinBrand())
  }
  return brandState
}

export function resolveApiBaseURL() {
  const host = hostName()
  if (host && host.endsWith('.buildbee.cn') && host !== 'zfapi.buildbee.cn') {
    return window.location.origin
  }
  return ZF_ORIGIN
}

export function applySiteBrand() {
  const brand = siteBrand()
  if (typeof document === 'undefined') return brand
  const path = window.location && window.location.pathname
  document.title = path === '/login' ? brand.loginTitle || brand.name : brand.name
  let link =
    document.querySelector("link[rel='icon']") ||
    document.querySelector("link[rel='shortcut icon']")
  if (!link) {
    link = document.createElement('link')
    link.rel = 'icon'
    document.head.appendChild(link)
  }
  link.href = brand.favicon
  return brand
}

async function fetchRemoteBrand() {
  const fallback = builtinBrand()
  assignBrand(fallback)
  applySiteBrand()
  if (typeof window === 'undefined' || !window.fetch) return fallback
  const host = hostName()
  if (!host) return fallback
  const controller = typeof AbortController !== 'undefined' ? new AbortController() : null
  const timer = setTimeout(() => {
    if (controller) controller.abort()
  }, 4000)
  try {
    const url =
      resolveApiBaseURL() +
      '/organize/temp/domainbrand/public?host=' +
      encodeURIComponent(host)
    const res = await fetch(url, {
      method: 'GET',
      credentials: 'omit',
      signal: controller ? controller.signal : undefined
    })
    if (!res.ok) return fallback
    const json = await res.json()
    if (!json || json.code !== 200 || !json.data) return fallback
    const merged = mergeBrand(json.data)
    assignBrand(merged)
    applySiteBrand()
    return brandState
  } catch (e) {
    assignBrand(fallback)
    applySiteBrand()
    return fallback
  } finally {
    clearTimeout(timer)
  }
}

export function loadSiteBrand(force) {
  if (!force && loadPromise && Date.now() - loadedAt < 60000) {
    return loadPromise
  }
  loadPromise = fetchRemoteBrand().then((brand) => {
    loadedAt = Date.now()
    return brand
  })
  return loadPromise
}

export function reloadSiteBrand() {
  loadedAt = 0
  loadPromise = null
  return loadSiteBrand(true)
}

assignBrand(builtinBrand())
